import $ from 'jquery'
import { viewModalEvent } from 'application/ga_view_modal_event'
SOPHIA.overlayBox = function(content, optionsObj, focusElement) {
  var options = optionsObj || {};

  SOPHIA.sophyOverlay.open(content, $.extend({}, options), focusElement);
  return false;
};

SOPHIA.closeOverlayBox = function() {
  SOPHIA.sophyOverlay.close();
};

// modal GA start
$(document).on('sophiaOverlay:afterLoad', function(e, $content) {
  $('.white, .ok, .lime', $content).off('.gaClick').on('click.gaClick', (e) => {
    SOPHIA.clickModalCloseForGA($(e.target))
  });
});

$(document).on('sophiaOverlay:afterShow', function(e, $content) {
  const isSpinnerPopup = $content.is('.sophypop-loading'),
    isFlexiblePage = $('body.flexible-layout:not(.touchstone-grading-page)').length,
    isDataOpenedModal = $('body').hasClass('data-opened-modal'); // modals are opened after clicking on links containing 'data-open-modal'

  if (!isSpinnerPopup && isFlexiblePage && !isDataOpenedModal) {
    const gaDataViewModal = { module_name: 'automated' };
    viewModalEvent(gaDataViewModal);
  }

  if ($('form[data-form-overlay]', $content).length) {
    SOPHIA.formGA($('form[data-form-overlay]', $content), 'form_view');
  }

  $('[data-sophypop-close]', $content)
    .off('.gaClick')
    .on('click.gaClick', (e) => {
      SOPHIA.clickModalCloseForGA($(e.target));
    });
})

$(document).on('sophiaOverlay:afterClose', function(e, $content) {
  SOPHIA.clickModalCloseForGA(false, $content);
  $('body').removeClass('data-opened-modal'); // remove additional class
});

SOPHIA.signInPopup = function(header_message, body_message, options, focusElement) {
  var $form = $('#you_must_be_signed');

  $('#header_message', $form).html(header_message);
  $('#body_message', $form).html(body_message);

  SOPHIA.overlayBox($form, {
    afterLoad: function() {
      $('.must-be-create-account').on('keydown', function(e) {
        if (e.keyCode == $.ui.keyCode.TAB && e.shiftKey) {
          e.preventDefault();
          SOPHIA.closeOverlayBox();
        }
      });
    }
  }, focusElement);

  return $form;
};

SOPHIA.confirm = function (message, callback, focusElement, options) {
  if ('undefined' == typeof options) options = {};
  options = $.extend({}, {
    onCancel:      function(){},
    onOk:          callback,
    onClose:       function(){},
    cancelCaption: 'Cancel',
    okCaption:     'OK',
    relaunchConfirm: false,
    popupTitle: ''
  }, options);

  var defaults = {
    btnTpl: {
      smallBtn: 'false'
    },
    clickSlide: false,
    keyboard : false,
    afterLoad: function(e) {
      bindConfirmForm(this, e, options);
    },
    beforeClose: function() {
      unbindConfirmForm();

      if (focusElement != 'undefined' && typeof focusElement == 'object') {
        focusElement.focus();
      }
    }
  };

  if (options.popupTitle != '') {
    options.popupTitle = '<h3>' + options.popupTitle + '</h3>';
  }

  var html = [
    '<div class="basicConfirm relaunchConfirm medium">',
      '<p>', message, '</p>',
      '<div class="buttons">',
        '<input class="cancel w-button white" type="button" value="', options.cancelCaption, '" />',
        '<input class="ok w-button purple" type="button" value="', options.okCaption, '" />',
      '</div>',
    '</div>'
  ].join('');

  var okLink,
      okLinkHref = typeof options.okHref == 'undefined' ? 'javascript:void(0)' : options.okHref;

  if (options.relaunchConfirm === true) {
    okLink = '<a href="' + okLinkHref +'" class="ok w-button purple">'+options.okCaption+'</a>';
  } else if (options.flexibleHtml === true) {
    okLink = '<input class="ok w-button purple" type="button" value="'+ options.okCaption+ '" />';
  }

  var flexibleHtml = [
    '<div class="basicConfirm flexible-popup medium">',
      options.popupTitle,
      '<p>', message, '</p>',
      '<div class="buttons">',
        okLink,
        '<input class="cancel w-button white" type="button" value="', options.cancelCaption, '" />',
      '</div>',
    '</div>'
  ].join('');

  if (options.relaunchConfirm === true || options.flexibleHtml === true) {
    SOPHIA.overlayBox(flexibleHtml, $.extend([], defaults, options), focusElement);
  } else {
    SOPHIA.overlayBox(html, $.extend([], defaults, options), focusElement);
  }
};

SOPHIA.sophypopShowActivity = function() {
  SOPHIA.preloader.open()
}

SOPHIA.sophypopHideActivity = function() {
  SOPHIA.preloader.close()
}

/* PRIVATE */

function bindConfirmForm(element, event, callbacks) {
  var $confirm = $('.basicConfirm, .relaunchConfirm');
  $('.ok', $confirm).on('click', function(){
    callbacks.onOk();
    SOPHIA.closeOverlayBox();
  });

  $('.cancel', $confirm).on('click', function(){
    callbacks.onCancel();
    SOPHIA.closeOverlayBox();
  });

  // to close popup after pressing SHIFT+TAB on the first element of overlay
  $('a:first-child, input:first-child', $confirm).on('keydown', function(e) {
    if (e.keyCode == $.ui.keyCode.TAB && e.shiftKey) {
      e.preventDefault();
      $('.close-popup').trigger('focus');
    }
  });
}

function unbindConfirmForm() {
  var $confirm = $('.basicConfirm');
  $('input[type=button]', $confirm).off();
}

